import { render, staticRenderFns } from "./IndemnityModalStepNewNosologicTemplate.vue?vue&type=template&id=1df2a123&scoped=true"
import script from "./IndemnityModalStepNewNosologicTemplate.vue?vue&type=script&lang=js"
export * from "./IndemnityModalStepNewNosologicTemplate.vue?vue&type=script&lang=js"
import style0 from "./IndemnityModalStepNewNosologicTemplate.vue?vue&type=style&index=0&id=1df2a123&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df2a123",
  null
  
)

export default component.exports